export const FETCH_MODULE = "FETCH_MODULE";
export const FETCH_MODULE_SUCCESS = "FETCH_MODULE_SUCCESS";
export const FETCH_MODULE_FAILURE = "FETCH_MODULE_FAILURE";

export const SAVE_MODULE = "SAVE_MODULE";
export const SAVE_MODULE_SUCCESS = "SAVE_MODULE_SUCCESS";
export const SAVE_MODULE_FAILURE = "SAVE_MODULE_FAILURE";

export const CHANGE_MODULE_STATUS = "CHANGE_MODULE_STATUS";
export const CHANGE_MODULE_STATUS_SUCCESS = "CHANGE_MODULE_STATUS_SUCCESS";
export const CHANGE_MODULE_STATUS_FAILURE = "CHANGE_MODULE_STATUS_FAILURE";

export const FETCH_MODULE_PROJECT_CLIENT_SERVICE = "FETCH_MODULE_PROJECT_CLIENT_SERVICE";
export const FETCH_MODULE_PROJECT_CLIENT_SERVICE_SUCCESS = "FETCH_MODULE_PROJECT_CLIENT_SERVICE_SUCCESS";
export const FETCH_MODULE_PROJECT_CLIENT_SERVICE_FAILURE = "FETCH_MODULE_PROJECT_CLIENT_SERVICE_FAILURE";
export const FETCH_MODULE_PROJECT_CLIENT_SERVICE_CLEAR = "FETCH_MODULE_PROJECT_CLIENT_SERVICE_CLEAR";
  
